import { MarkerProps } from "@cofano/cck";
import { Box, useTheme } from "@mui/material";
import WaterLevels from "view/waterlevels/WaterLevels";
import WaterlevelMarker from "../markers/WaterlevelMarker";

const MapWaterLevelTab = ({ onChange }: {
	onChange: (markers: MarkerProps[]) => void;
}) => {
	const theme = useTheme();
	return (
		<Box
			pt={2}
			pb={2}
			pl={3}
			pr={3}
			sx={{ backgroundColor: theme.palette.mode === "dark" ? "inherit" : "#F1F1F1" }}>
			<WaterLevels
				hidePageTitle={true}
				disableBreakPoints={true}
				onChange={(personalLevels) => {

					const markers: MarkerProps[] = [];

					personalLevels.forEach((level) => {
						if (level.latitude && level.longitude) {
							markers.push({
								lat: level.latitude,
								lng: level.longitude,
								label: level.name,
								component: () => (
									<WaterlevelMarker
										level={level}
										onClick={() => {
											document.getElementById(`waterlevel-${level.id}`)?.scrollIntoView({
												behavior: "smooth",
											});
										}} />
								),
							});
						}
					});

					onChange(markers);
				}} />
		</Box>
	);
};

export default MapWaterLevelTab;
